import {useRef} from 'react';
import {view} from '@sail/ui';
import {
  useNewUniversalHelpDesign,
  useUniversalHelpDotComDesign,
} from '../../../FeatureFlagsProvider';

type Props = {
  rows: Array<JSX.Element>;
  fillSpace?: boolean;
};

export function GroupedMessagesRowV2({rows, fillSpace}: Props) {
  const useNewDesign = useNewUniversalHelpDesign();
  const useDotComDesign = useUniversalHelpDotComDesign();

  // The behavior for filling space is only read once. We ignore all
  // future changes. This allows us to turn it on/off and only affect
  // future messages; we never want to shift the layout of existing
  // messages
  const fillSpaceRef = useRef(fillSpace);

  if (rows.length === 0) {
    return null;
  }

  let gap = 'xsmall';

  if (useNewDesign) {
    gap = 'large';
  } else if (useDotComDesign) {
    gap = 'small';
  }

  return (
    <view.div
      className={`uh-conversations-grouped-messages-v2 ${
        fillSpaceRef.current ? 'fill-space' : ''
      }`}
      data-testid="grouped-messages-row"
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap,
      }}
    >
      {rows}
    </view.div>
  );
}
